import type { CancelToken } from 'axios';
import Axios from 'axios';
import type { LockboxesActivityFilterOptions } from 'api/get/getListingAccessActivities';
import type { SupraLockboxActivity } from '../../Router/pages/LockboxesActivityPage/types';

export const getSupraLockboxActivitiesLink = ({
  page = 1,
  filters,
  sort,
  exportCsvType,
}: {
  filters?: LockboxesActivityFilterOptions;
  sort?: {
    sort: string;
    order: 'ascend' | 'descend';
  };
  page?: number;
  exportCsvType?: 'none' | 'default' | 'quickLockbox';
}): string => Axios.getUri({
    url: '/supra/lockbox/activities',
    params: {
      ...filters,
      page: page - 1,
      ...(sort && {
        sortBy: sort.sort,
        sortOrder: sort.sort && (sort.order === 'descend' ? 'desc' : 'asc'),
      }),
      exportCsvType,
    },
  });

const getSupraLockboxActivities = async ({
  page = 1,
  filters,
  sort,
  cancelToken,
}: {
  filters?: LockboxesActivityFilterOptions;
  sort?: {
    sort: string;
    order: 'ascend' | 'descend';
  };
  page?: number;
  cancelToken?: CancelToken;
}): Promise<{
  activities: SupraLockboxActivity[];
  count: number;
}> => {
  const url = getSupraLockboxActivitiesLink({
    page,
    filters,
    sort,
  });

  const result = await Axios.get(url, { cancelToken });
  return result.data;
};

export default getSupraLockboxActivities;
